<template>
  <div class="form-designer">
    <el-container :style="containerStyle">
      <!-- 左侧字段 -->
      <el-aside :width="leftWidth">
        <div class="fields-list">
          <div v-for="(field, index) in fields"
              :key="index">
            <div v-if="!field.disabled" :style="{paddingBottom: index===3 && mode === 2 ? '70px': 0}">
              <div class="field-title">{{field.title}}</div>
              <draggable tag="ul"
                         :list="field.list"
                         :group="{ name: 'form', pull: 'clone', put: false }"
                         ghost-class="ghost"
                         :sort="false">
                <li class="field-label"
                    v-for="(item, index) in field.list"
                    :key="index">
                  <a>
                    <i class="icon iconfont"
                       :class="item.icon"></i>
                    <span>{{item.label}}</span>
                  </a>
                </li>
              </draggable>
            </div>
            <div v-else>
              <div class="field-title">{{field.title}}
                <span class="danger">（开发中）</span>
              </div>
              <ul>
                <li class="field-label-disabled"
                    v-for="(item, index) in field.list"
                    :key="index">
                  <a>
                    <i class="icon iconfont"
                       :class="item.icon"></i>
                    <span>{{item.label}}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-aside>
      <!-- 中间主布局 -->
      <el-container class="widget-container" :style="containerStyle + '!important;'"
                    direction="vertical">
        <el-header class="widget-container-header">
          <div />
          <div>
            <el-button type="text"
                        size="medium"
                        icon="el-icon-upload2"
                        @click="importJsonVisible = true">导入JSON</el-button>
            <el-button type="text"
                        size="medium"
                        icon="el-icon-download"
                        @click="handleGenerateJson">生成JSON</el-button>
            <el-button type="text"
                        size="medium"
                        icon="el-icon-view"
                        @click="handlePreview">预览</el-button>
            <el-button type="text"
                      v-if="mode === 1"
                      size="medium"
                      icon="el-icon-upload"
                      @click="handleSave">保存</el-button>
            <el-button class="danger"
                      v-if="mode === 1"
                      type="text"
                      size="medium"
                      icon="el-icon-close"
                      @click="handleCancel">取消</el-button>
          </div>
        </el-header>
        <el-main :style="{background: widgetForm.column.length == 0 ? `url(${widgetEmpty}) no-repeat 50%`: ''}">
          <widget-form
          :mode="mode"
          ref="widgetForm"
          :data="widgetForm"
          :select.sync="widgetFormSelect"
          @change="handleHistoryChange(widgetForm)"></widget-form>
        </el-main>
      </el-container>

      <el-aside class="widget-config-container"
                :width="asideRightWidth">
                    <el-tabs v-model="configTab"
                 stretch>
                    <el-tab-pane label="字段属性"
                       name="widget"
                       style="padding: 0 10px;">
                    <widget-config :data="widgetFormSelect" :widgetForm="widgetForm"></widget-config>
                    </el-tab-pane>
                    <el-tab-pane label="表单属性"
                       name="form"
                       lazy
                       style="padding: 0 10px;">
                    <form-config :data="widgetForm"></form-config>
                    </el-tab-pane>
                    </el-tabs>
       </el-aside>
      <!-- 弹窗 -->
      <!-- 导入JSON -->
      <el-drawer title="导入JSON"
                 :visible.sync="importJsonVisible"
                 size="70%"
                 :style="zoomScaleStyle"
                 destroy-on-close
                 :modal-append-to-body="false"
                 >
        <v-json-editor v-model="importJson"
                       :height="jsonEditerHeight"></v-json-editor>
        <div class="drawer-foot">
          <el-button size="medium"
                     type="primary"
                     @click="handleImportJsonSubmit">确定</el-button>
          <el-button size="medium"
                     type="danger"
                     @click="importJsonVisible = false">取消</el-button>
        </div>
      </el-drawer>
       <!--生成JSON-->
      <el-drawer title="生成JSON"
                 :visible.sync="generateJsonVisible"
                 size="70%"
                 :style="zoomScaleStyle"
                 destroy-on-close
                 :modal-append-to-body="false"
                 >
        <v-json-editor v-model="option"
                       :height="jsonEditerHeight"></v-json-editor>
      </el-drawer>

      <!--预览-->
      <el-drawer :title="widgetForm.tableComment"
                 :visible.sync="previewVisible"
                 size="70%"
                 :before-close="handleBeforeClose"
                 :modal="false"
                 append-to-body
      >
        <avue-form v-if="previewVisible"
                   ref="form"
                   class="preview-form"
                   :option="option"
                   v-model="form"
                   @submit="handlePreviewSubmit"
                   :upload-after="uploadAfter"
                   :upload-before="uploadBefore"
                   :upload-preview="uploadPreview" >

        </avue-form>
        <div class="drawer-foot">
          <el-button size="medium"
                     type="primary"
                     @click="handlePreviewSubmit">确定</el-button>
          <el-button size="medium"
                     type="danger"
                     @click="handleBeforeClose">取消</el-button>
        </div>
      </el-drawer>
    </el-container>

  </div>
</template>

<script>
import fields from './fieldsConfig.js'
import widgetEmpty from './assets/widget-empty.png'
import conf from '@/workFlow/workFlow/publicConfig/inputConf'
import { getRemoteDataByParams, cascadeLocal, setHeaderBeforeFileUpload, donwloadFileOnClick, changeConfigToForm, modifyFormModelData, controlHideByCondition, uploadBefore, uploadAfter, downloadFileBeforePreview } from '@/workFlow/utils/formUtil'
import { getToken } from '@/framework/util/auth'
import avueIndex from './mixins/avueindex'
import history from './mixins/history'

export default {
  name: 'FormDesign',
  mixins: [avueIndex, history],
  components: {
    DraggableL: () => import(/* webpackChunkName: 'workFlowFormDesign' */'vuedraggable'),
    VJsonEditor: () => import(/* webpackChunkName: 'workFlowFormDesign' */'v-jsoneditor'),
    WidgetForm: () => import(/* webpackChunkName: 'workFlowFormDesign' */'./WidgetForm'),
    FormConfig: () => import(/* webpackChunkName: 'workFlowFormDesign' */'./FormConfig'),
    WidgetConfig: () => import(/* webpackChunkName: 'workFlowFormDesign' */'./WidgetConfig'),
    transfer: () => import(/* webpackChunkName: 'workFlowFormDesign' */'@/workFlow/formComponent/formTransfer/fromtransfer')
  },
  props: {
    mode: {
      type: Number,
      default: 1
    },
    options: {
      type: Object,
      default: () => {
        return {
          column: []
        }
      }
    },
    asideLeftWidth: {
      type: [String, Number],
      default: '23%'
    },
    asideRightWidth: {
      type: [String, Number],
      default: '27%'
    }
  },
  watch: {
    widgetForm: {
      handler(val) {
        if (this.mode !== 1) {
          this.$emit('on-mode', val)
        }
        /* if (val.jsPath.length > 0 && val.jsPath.endsWith(".js")) {
          console.log('got a js path')

          var script = document.createElement('script')
          script.type = 'text/javascript'
          script.src = './static/testHello.js'
          script.id = 'testjs'
          document.getElementsByTagName('head')[0].appendChild(script)
          console.log(document.getElementsByTagName('script'))
          /!*changeFormData(val)*!/

        }*/
      },
      deep: true
    },
    form: {
      handler(val) {
        if (this.widgetForm.jsPath && this.widgetForm.jsPath.endsWith('.js')) {
          // changeWidgetFormData(this.widgetModels, this.widgetForm)
        }
        cascadeLocal(val, this.widgetForm, this.$http, this.$message)

        controlHideByCondition(val, this.widgetForm)

        /* let dynamicHideProp
        let dynamicHideCondition
        let prop

        if (this.widgetForm.column && this.widgetForm.column.length > 0){
          for(let i = 0; i < this.widgetForm.column.length; i++){

              if(this.widgetForm.column[i].dynamicHideProp && this.widgetForm.column[i].dynamicHideCondition){
                prop = this.widgetForm.column[i].prop
                dynamicHideProp = this.widgetForm.column[i].dynamicHideProp
                dynamicHideCondition = this.widgetForm.column[i].dynamicHideCondition
              }

          }
        }
        console.log(dynamicHideProp)
        console.log(dynamicHideCondition)
        console.log(val)
        for(let key in val){
          if(key === prop  ){
            for(let i = 0; i < this.widgetForm.column.length; i++){
                if(this.widgetForm.column[i].prop === dynamicHideProp){
                  if(val[key] === dynamicHideCondition){
                    this.widgetForm.column[i].display = true
                  }else {
                    this.widgetForm.column[i].display = false
                  }

                }

            }
          }
        }*/
      },
      deep: true
    }

  },
  computed: {
    zoomScaleStyle() {
      if (document.documentElement.style.zoom) {
        let scale = 1 / document.documentElement.style.zoom
        return 'zoom:' + scale + ''
      }
      return ''
    },
    jsonEditerHeight() {
      if (document.documentElement.style.zoom) {
        let scale = 85 / document.documentElement.style.zoom
        return scale + 'vh'
      }
      return '85vh'
    },
    containerStyle() {
      if (document.documentElement.style.zoom) {
        let scale = 82 / document.documentElement.style.zoom
        return 'height:' + scale + 'vh'
      }
      return 'height:82vh'
    },
    leftWidth() {
      if (typeof this.asideLeftWidth === 'string') {
        return this.asideLeftWidth
      } else {
        return `${this.asideLeftWidth}px`
      }
    },
    rightWidth() {
      if (typeof this.asideRightWidth === 'string') {
        return this.asideRightWidth
      } else {
        return `${this.asideRightWidth}px`
      }
    }
  },
  data() {
    return {
      conf,
      widgetEmpty: widgetEmpty,
      fields,
      widgetForm: {
        column: [],
        labelPosition: 'left',
        labelWidth: 100,
        formId: '',
        gutter: 0,
        menuBtn: false,
        submitBtn: false,
        submitSize: 'medium',
        submitText: '提交',
        emptyBtn: false,
        emptySize: 'medium',
        emptyText: '清空',
        menuPosition: 'center'
      },
      widgetFormPreview: {},
      configTab: 'widget',
      widgetFormSelect: {},
      previewVisible: false,
      generateJsonVisible: false,
      importJsonVisible: false,
      importJson: undefined,
      // widgetModels: { 'scholarId': '1', 'year': '2018', 'upload': [{ 'label': 'avue@226d5c1a_logo.png', 'value': '/images/logo-bg.jpg' }] },
      configOption: {}

    }
  },
  mounted() {
    /** 初始化设计器,使外部传入的 prop options 合并 */
    this.initializeDesigner()
  },
  methods: {

    uploadPreview(file, column) {
      console.log('hello preview')
      console.log(file)
    },
    uploadBefore(file, done, loading, column) {
      uploadBefore(file, done, loading, column)
    },
    uploadAfter(ress, done, loading, column) {
      uploadAfter(ress, done, loading, column, this.form, this.$downloadFile, this.$message)
    },

    initializeDesigner() {
      this.setJSON({ ...this.widgetForm, ...this.options })
    },

    /** 导入JSON */
    handleImportJsonSubmit() {
      try {
        this.setJSON(this.importJson)
        this.transAvueOptionsToFormDesigner(this.importJson).then(res => {
          this.widgetForm = res
          this.importJsonVisible = false
          this.handleHistoryChange(this.widgetForm)
        })
      } catch (e) {
        this.$message.error(e.message)
      }
    },

    handleBeforeClose() {
      // this.$refs.form.resetForm()
      this.previewVisible = false
    },

    handlePreview() {
      if (!this.widgetForm.column || this.widgetForm.column.length === 0) this.$message.error('没有需要展示的内容')
      else {
        this.transformToAvueOptions(this.widgetForm, true).then(data => {
          this.option = data
          this.previewVisible = true
          setHeaderBeforeFileUpload(this.widgetForm, getToken())
          // console.log(this.widgetForm.column) //15 26
          getRemoteDataByParams(this.widgetForm, this.$http, this.$message, this.form).then(() => {
            this.previewVisible = true
            setTimeout(() => {
              donwloadFileOnClick(this.$refs.form, this.$downloadFile, this.form, this.$message)
            })

            modifyFormModelData(this.widgetForm, this.conf)
          })
        })
      }
    },
    // handleGenerateJson() {
    //   const data = this.deepClone(this.widgetForm)
    //   data.column.forEach(col => {
    //     if (col.type === 'dynamic' && col.children && col.children.column && col.children.column.length > 0) {
    //       const c = col.children.column
    //       c.forEach(item => {
    //         delete item.subfield
    //         delete item.parentIsTable
    //       })
    //     }
    //   })
    //   this.widgetFormPreview = data
    //   this.generateJsonVisible = true
    // },

    // handlePreviewSubmit() {
    //   this.$refs.form.validate((valid) => {
    //     if (valid) {
    //       this.$alert(this.widgetModels)
    //     }
    //   })
    // },

    /** 打开avue 文档  */
    handleAvueDoc() {
      window.open('https://avuejs.com/doc/form/form-doc', '_blank')
    },
    /** 保存表单模型 */
    handleSave() {
      /** 将管理部门从数组中解析出来 */
      let manageOrgId = null
      if (this.widgetForm.manageOrgan && this.widgetForm.manageOrgan.length) {
        manageOrgId = this.widgetForm.manageOrgan[0].id
      }

      /** 将模板从数组中解析出来 */
      let templatePath = null
      if (this.widgetForm.templatePathFileList && this.widgetForm.templatePathFileList.length) {
        templatePath = this.widgetForm.templatePathFileList[0].fileUniqueCode
      }
      this.transformToAvueOptions(this.widgetForm).then(data => {
        this.$http.post('/form-model/save', data, {
          params: {
          // 表单类型
            type: 'process',
            manageOrgId,
            templatePath
          }
        }).then(response => {
          this.$message.success('保存成功')
          this.$router.go(-1)
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
      })
      // 提交保存到服务器
      // this.$http.post('/form-model/save', this.deepClone(this.widgetForm), {
      //   params: {
      //     // 表单类型
      //     type: 'process',
      //     manageOrgId,
      //     templatePath
      //   }
      // }).then(response => {
      //   this.$message.success('保存成功')
      //   this.$router.go(-1)
      // }).catch(error => {
      //   this.$message.error(error.msg || error.message)
      // })
    },
    /** 返回 */
    handleCancel() {
      this.$confirm('之前的操作尚未保存,取消后数据将会丢失, 是否继续?', '确认取消', { cancelButtonText: '取消', confirmButtonText: '确定', type: 'warning' }).then(() => {
        this.$router.go(-1)
      }).catch(() => {})
    },

    // transformToAvueOptions() {
    //   return new Promise((resolve, reject) => {
    //     try {
    //       const data = this.deepClone(this.widgetForm)
    //       data.column.forEach(col => {
    //         if (col.type === 'dynamic' && col.children && col.children.column && col.children.column.length > 0) {
    //           const c = col.children.column
    //           c.forEach(item => {
    //             delete item.subfield
    //             delete item.parentIsTable
    //           })
    //         }
    //       })
    //       resolve(data)
    //     } catch (e) {
    //       reject(e)
    //     }
    //   })
    // },
    // 设置json
    setJSON(json) {
      this.widgetForm = json
      if (json.column && json.column.length > 0) {
        this.widgetFormSelect = json.column[0]
        json.column.forEach(col => {
          if (col.type === 'dynamic' && col.children && col.children.column && col.children.column.length > 0) {
            // 不知道干嘛的操作
            col.children.column.forEach(item => {
              item.subfield = true
              if (col.isTable) {
                item.parentIsTable = true
              }
            })
          }
        })
      }
    }
  },
  updated() {
    if (this.widgetForm.column && this.widgetForm.column.length > 0) {
      setTimeout(() => {
        changeConfigToForm(document.getElementsByTagName('label'), this.widgetForm)
      })
    }
  }

}
</script>

<style lang="scss">
@import "styles/index.scss";
.drawer-foot {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  display: flex;

  button {
    width: 50%;
  }
}

.preview-form {
  overflow-y: scroll;
  height: 83vh;
}

.widget-config-container {
  .avue-group__item {
    padding: 0;
  }
}

</style>
